'use strict';
import $ from 'jquery';

export default class Search {
    constructor() {
        $(document).on('click', '.show-search', this.openSearchOverlay.bind(this));
        this.searchOverlay = $('.search-overlay');
        this.searchOverlay.on('click', 'a', this.closeSearchOverlay.bind(this));
        this.searchInput = this.searchOverlay.find('input[type=search]');


        $('.search-results-sidebar').on('click', 'input.toggle', (e) => {
            if ($(this).prop('checked')) {
                $('.search-results-sidebar').find('ul').slideUp();
                $(this).prop('checked', false);
            } else {
                $('.search-results-sidebar').find('ul').slideDown({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        });
                    }
                });
                $(this).prop('checked', true);
            }
        });

        // When switching from mobile to desktop, if the sidebar was collapsed while in mobile, undo that hiding of it.
        this.oldScreenWidth = $(window).outerWidth();
        $(window).on('resize', () => {
            if ($(window).outerWidth() > 767 && this.oldScreenWidth < 768) {
                // this.el.find('.module-m107-sidebar-items').css('max-height', 'none');
                $('.search-results-sidebar').find('ul').show();
                $('.search-results-sidebar input[type=checkbox]').prop('checked', false);
            } else if ($(window).outerWidth() < 768 && this.oldScreenWidth > 767) {
                $('.search-results-sidebar').find('ul').hide();
                $(this).prop('checked', false);
            }
            this.oldScreenWidth = $(window).outerWidth();
        });
    }

    openSearchOverlay() {
        this.searchOverlay.addClass('open');
        this.searchInput.trigger('focus');
        $(document).on('keyup.searchOverlay', (e) => {
            if (e.key === 'Escape') {
                this.closeSearchOverlay();
            }
        });
    }

    closeSearchOverlay() {
        $('.search-overlay').removeClass('open');
        $(document).off('keyup.searchOverlay');
    }
}